import { TableRow, styled } from '@mui/material';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  height: 40,
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

export default StyledTableRow;
